export class FreelancerlistAPIModel {

  FreelancerdataAPI: any;
  GetFreelancerReportsAPI: any;
  getFreelancerbyIdAPI: string;
  PartialUploadMsg: any;
  FreelancertestallocationAPI: any;
  LanguageListAPI: any;
  InterestListAPI: any;
  SourceListAPI: any;
  CityListAPI: any;
  StateListAPI: any;
  CountryListAPI: any;
  CheckDuplicateAPI: any;
  UpdateFreelancerAPI: any;
  getFreelancertestfileAPI: string;
  getFreelancerResumefileAPI: string;
  CorrectiontestfileAPI: string;
  UpdateTestResultAPI: string;
  FreelancerTestDetailsById: string;
  CategoryListAPI: string;
  GetAvailableDate: string;
  GetAvailablestatus: string;
  FreelancerTestDownload: any;
  ArticleTitleAPI: any;
  ArticleListAPI: any;
  FreelancerTestFileDeletebyID: string;
  FreelancerTestAllocation: any;
  FreelancerTestAssesment: string;
  GetFreelancerAssignmentPending: string;
  GetFreelancerDashboardSummary: any;
  getFreelancerUploadedTestFileDownload: any;
  GetInviteEmailTemplateAPI: any;
  SendFreelancerInviteAPI: any;
  CheckDuplicateFreelancer: any;
  DeclineFreelancerbyID: string;
  ApproveFreelancerbyID: any;
  FreelancerAssessmentInfo: string;
}
